<template>
  <t-dialog
    :visible="visible"
    header="修改密码"
    placement="center"
    width="600"
    :confirm-btn="{
      content: '提交',
      theme: 'primary',
      loading,
    }"
    :cancel-btn="{
      content: '关闭',
    }"
    :on-confirm="handleSubmit"
    :on-close="handleClose"
  >
    <t-form ref="form" :data="formData" colon :rules="rules" reset-type="initial">
      <t-form-item label="旧密码" name="oldPassword">
        <t-input v-model="formData.oldPassword" type="password" placeholder="请输入旧密码" />
      </t-form-item>
      <t-form-item label="新密码" name="newPassword">
        <t-input v-model="formData.newPassword" type="password" placeholder="请输入新密码" />
      </t-form-item>
      <t-form-item label="确认密码" name="confirmPassword">
        <t-input v-model="formData.confirmPassword" type="password" placeholder="请再次输入新密码" />
      </t-form-item>
    </t-form>
  </t-dialog>
</template>
<script setup>
import { MessagePlugin } from 'tdesign-vue-next';
import { ref } from 'vue';
import { useRouter } from 'vue-router';

import { updateOwnPassword } from '@/api/login';
import { useUserStore } from '@/store';
import { ADMIN_PASSWORD_RULES } from '@/utils/password';

const router = useRouter();

// 加载状态
const loading = ref(false);

// 弹窗状态
const visible = ref(false);
const handleDialog = () => {
  visible.value = true;
};

// 用户store
const userStore = useUserStore();

// 表单数据
const form = ref(null);
const formData = ref({
  oldPassword: '',
  newPassword: '',
  confirmPassword: '',
});

// 校验规则
const rules = ref({
  oldPassword: [{ required: true, message: '请输入旧密码' }],
  newPassword: ADMIN_PASSWORD_RULES,
  confirmPassword: [
    { required: true, message: '请再次输入新密码' },
    {
      validator: (val) => val === formData.value.newPassword,
      message: '两次输入的密码不一致',
    },
  ],
});

// 提交
const handleSubmit = () => {
  form.value.validate().then(async (e) => {
    if (e === true) {
      loading.value = true;
      try {
        const { code, msg } = await updateOwnPassword(formData.value);
        if (code === 200) {
          MessagePlugin.success(msg);
          await userStore.logout();
          router.push('/login');
        }
      } catch (e) {
        console.log(e);
      } finally {
        loading.value = false;
      }
    }
  });
};

// 关闭弹窗
const handleClose = () => {
  visible.value = false;
  form.value.reset();
};

// 暴露
defineExpose({
  handleDialog,
});
</script>
<style lang="less" scoped></style>
